import { schema } from 'normalizr';

export const surveySchema = new schema.Entity('survey', {}, { idAttribute: '_id' });
